export const ContactIconSizes = {
    Small: 'small',
    Medium: 'medium',
    Large: 'large',
    XLarge: 'x-large',
} as const;

export type ContactIconSize =
    (typeof ContactIconSizes)[keyof typeof ContactIconSizes];
